/**
 * メンバー詳細ページ (`/members/$email`) の「DLE評価」タブ。
 *
 * MyPage のタブと表示本体 (`DleEvaluationPanel`) は共通で、違いは**対象の決まり方**だけ。
 * ここはページのメンバー固定なので切替を出さない。email → nickname の解決はサーバ側
 * (`GET /dle-evaluation/scores?email=`) に任せる。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business メンバー詳細ページで、そのメンバーが DLE として受けた評価を表示する
 */
import { useDleScoresByEmail } from '../../../hooks/useDleEvaluationSurvey.js';
import { DleEvaluationPanel } from './DleEvaluationTab.js';

/**
 * メンバー詳細の「DLE評価」タブ本体。
 *
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business メンバー詳細ページの DLE 評価タブ。対象はページのメンバー固定で切替は出さない
 * @graph-connects useDleScoresByEmail [calls] メンバーの DLE 評価集計取得（閲覧権限必須）
 * @graph-connects DleEvaluationPanel [calls] 評価の表示本体
 */
export function MemberDleEvaluationTab({ email }: { email: string }) {
  const { data, isLoading } = useDleScoresByEmail(email);
  // 対象名は見出しに出す。メンバー詳細はページ自体が 1 人ぶんなので切替は渡さない。
  return <DleEvaluationPanel data={data} isLoading={isLoading} targetLabel={data?.dle ?? null} />;
}
